// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"77d86395","869":"448891a3"}[chunkId] + ".chunk.js";
};